import type { SubmissionManagementPlanKey } from '@ebalance/proto/bffuser/v1/submission_management_model_pb'

/**
 * 解消・対応メモの RPC (spec submission-management.md §7) が対象にする計画。
 *
 * 版の詳細は版の ID (`planSubmissionId`) で、eBalance に提出記録の無い計画の詳細
 * (AC-PPD-028) は業務キー (`planKey`) で計画を指す。proto の request は 2 つの field の
 * どちらか一方だけを送る契約なので、片方を空文字で送る誤りを型で防ぐために union にする。
 */
export type PlanTarget =
  | { planSubmissionId: string }
  | { planKey: SubmissionManagementPlanKey }

/** request に載せる対象の field。指定しない側は送らない (proto の既定値のまま)。 */
export function toPlanTargetRequest(
  target: PlanTarget,
): { planSubmissionId: string } | { planKey: SubmissionManagementPlanKey } {
  return 'planKey' in target
    ? { planKey: target.planKey }
    : { planSubmissionId: target.planSubmissionId }
}

/** 対象を読める状態か (版の ID が空の間は取得しない)。業務キーは呼び出し側が組めた時だけ渡す。 */
export function isPlanTargetReady(target: PlanTarget): boolean {
  return 'planKey' in target || target.planSubmissionId !== ''
}
